<br />

<h1>{{ title.getTitle() }}</h1>

<hr />

<pcg-table [canGlobalSearch]="false" [multipleSearch]="false" [pcgSort]="[['goLiveDateString', 'desc']]"
	dataSource="api/ReleaseNotes/GetReleaseNotesList" [columnDefs]="columns">

	<ng-container cdkColumnDef="versionNumber">
		<th width="15%" cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('versionNumber').displayName }}</th>
		<td cdk-cell *cdkCellDef="let row" data-label="Version Number">{{ row.versionNumber }}</td>
	</ng-container>

	<ng-container cdkColumnDef="goLiveDateString">
		<th width="15%" cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('goLiveDateString').displayName }}</th>
		<td cdk-cell *cdkCellDef="let row" data-label="Go Live Date">{{ row.goLiveDateString }}</td>
	</ng-container>

	<ng-container cdkColumnDef="releaseNotesDescription">
		<th width="70%" cdk-header-cell *cdkHeaderCellDef>{{ columns.get('releaseNotesDescription').displayName }}</th>
		<td cdk-cell *cdkCellDef="let row" [innerHTML]="row.releaseNotesDescription" data-label="Description of Change"></td>
	</ng-container>

</pcg-table>
